import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  orderReusableGridButtonRemoveHold: {
    description: 'orderReusableGridButton.removeHold',
    defaultMessage: 'Remove Hold',
    id: 'kziY5K',
  },
  orderReusableGridButtonMarkAsShipped: {
    description: 'Order reusable grid button - Mark as shipped',
    defaultMessage: 'Mark as Shipped',
    id: 'urTf4y',
  },
  orderReusableGridButtonMarkAsPaid: {
    description: 'orderReusableGridButton.markAsPaid',
    defaultMessage: 'Mark as Paid',
    id: 'flAHce',
  },
  orderReusableGridButtonMarkAsReadyToPick: {
    description: 'orderReusableGridButton to create a new label batch and mark orders as ready to be picked',
    defaultMessage: 'Ready to Pick',
    id: 'dgMqb/',
  },
  orderReusableGridButtonHold: {
    description: 'orderReusableGridButton.hold',
    defaultMessage: 'Hold',
    id: '3Wb812',
  },
  orderReusableGridRestoreOrder: {
    description: 'orderReusableGridButton.restoreOrder',
    defaultMessage: 'Restore Order',
    id: '2CIqEH',
  },
  orderReusableGridRestore: {
    description: 'orderReusableGridButton.restore',
    defaultMessage: 'Restore',
    id: 'SGO4Xh',
  },
  orderReusableGridNewOrder: {
    description: 'orderReusableGridButton.newOrder',
    defaultMessage: 'New Order',
    id: 'geZ87r',
  },
  orderReusableGridNewOrderTooltip: {
    description: 'orderReusableGridButton.newOrderTooltip',
    defaultMessage:
      'There are no ShipStation Manual Order stores currently active. Please reactivate a store from Account Settings > Selling Channels to enable creating new manual orders.',
    id: 'ou5W+q',
  },
  orderReusableGridGetRate: {
    description: 'orderGridOtherActions.getRate',
    defaultMessage: 'Get Rate',
    id: 'vYJl60',
  },
  orderReusableGridRestoreShipment: {
    description: 'orderReusableGridButton.restore',
    defaultMessage: 'Restore',
    id: 'SGO4Xh',
  },
  orderReusableGridRestoreShipmentTooltip: {
    description: 'orderReusableGridButton.restoreTooltip',
    defaultMessage: 'Moves shipment from the Shipped status to the Awaiting Shipment status',
    id: '9JEyeH',
  },
  orderReusableGridRestoreDisabledTooltip: {
    description: 'orderReusableGridButton.restoreDisabledTooltip',
    defaultMessage:
      'Orders delegated to you cannot be restored after you have cancelled them. This is to prevent merchant confusion over the status of the order. If you cancelled this order by mistake and wish to fulfill it, please contact the merchant directly to coordinate.',
    id: 'k5isDS',
  },
  orderReusableGridImportOrders: {
    description: 'orderGridOtherActions.importOrders',
    defaultMessage: 'Import Orders',
    id: 'rj0Asc',
  },
  isDemoDisabledMessage: {
    description: 'Disabled message for Hold button when demo orders are selected',
    defaultMessage: 'This action is disabled for Demo Orders',
    id: 'L11ehM',
  },
});
